import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2,
  class: "out_of_court"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", {
  style: {
    "font-size": "24px"
  }
}, "申请失败", -1);
const _hoisted_7 = {
  style: {
    "color": "red"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ajax } from '@/api/ajax.js';
export default {
  __name: 'index',
  setup(__props) {
    const formSize = ref('default');
    const resubmitRuleFormRef = ref();
    const ruleFormRef = ref();
    // 头像的显示图片地址
    const resubmitImageUrl = ref();
    // 营业执照的显示图片地址
    const resubmitZilUrl = ref();
    const imageUrl = ref();
    const zilUrl = ref();
    const shop = ref({});
    const show = ref(true);
    const router = useRouter();
    const ruleForm = reactive({
      name: '',
      phone: '',
      weixin: '',
      img: '',
      zil: '',
      ne: ''
    });
    const resubmitForm = reactive({
      name: '',
      phone: '',
      weixin: '',
      img: '',
      zil: '',
      ne: ''
    });
    const rules = reactive({
      name: [{
        required: true,
        message: '名字不能为空',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '手机号不能为空',
        trigger: 'blur'
      }, {
        min: 11,
        message: '手机号不规范，最少为11位数',
        trigger: 'blur'
      }],
      img: [{
        required: true,
        message: '头像不能为空',
        trigger: 'blur'
      }],
      zil: [{
        required: true,
        message: '营业执照不能为空',
        trigger: 'blur'
      }],
      ne: [{
        min: 2,
        max: 2,
        message: '请输入俩个字',
        trigger: 'blur'
      }, {
        required: true,
        message: '别名不能为空',
        trigger: 'blur'
      }]
    });
    const submitForm = async formEl => {
      if (!ruleForm.xy) {
        ElMessage({
          type: 'error',
          message: '请勾选协议'
        });
        return false;
      }
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          ajax('Merchant/addshop', res => {
            if (res.code == 0) {
              ElMessage({
                type: 'success',
                message: res.msg
              });
              show.value = false;
              getShop();
            }
          }, error => {
            ElMessage({
              type: 'error',
              message: error.msg
            });
          }, ruleForm);
        } else {}
      });
    };
    const getShop = () => {
      ajax('Merchant/datalist', res => {
        if (res.shop.zt == 1) {
          router.push('/');
        }
        if (res.shop.zt == 0) {
          shop.value = res.shop;
          show.value = false;
        }
        if (res.shop.zt == 2) {
          shop.value = res.shop;
          show.value = false;
          resubmitImageUrl.value = `https://file.y-sjf.com/ipfs/${res.shop.img}`;
          resubmitZilUrl.value = `https://file.y-sjf.com/ipfs/${res.shop.zil}`;
          resubmitForm.img = res.shop.img;
          resubmitForm.name = res.shop.name;
          resubmitForm.phone = res.shop.phone;
          resubmitForm.weixin = res.shop.weixin;
          resubmitForm.zil = res.shop.zil;
          resubmitForm.ne = res.shop.ne;
        }
      }, error => {
        shop.value = error.data;
        if (error.code != 101) {
          show.value = false;
        }
        // 被驳回的情况
      });
    };

    getShop();

    //头像上传
    const getImg = async item => {
      ajax('User_fun/up_img', data => {
        imageUrl.value = data.url;
        ruleForm.img = data.data;
      }, error => {
        ElMessage({
          type: 'error',
          message: error.msg
        });
      }, {
        file: item.file
      });
    };
    //营业执照
    const getZil = async item => {
      ajax('User_fun/up_img', data => {
        zilUrl.value = data.url;
        ruleForm.zil = data.data;
      }, error => {
        ElMessage({
          type: 'error',
          message: error.msg
        });
      }, {
        file: item.file
      });
    };
    // 重新上传头像事件
    const resubmitgetImg = item => {
      ajax('User_fun/up_img', data => {
        resubmitImageUrl.value = data.url;
        resubmitForm.img = data.data;
      }, error => {
        ElMessage({
          type: 'error',
          message: error.msg
        });
      }, {
        file: item.file
      });
    };
    // 重新上传营业执照的事件
    const resubmitgetZil = item => {
      ajax('User_fun/up_img', data => {
        resubmitZilUrl.value = data.url;
        resubmitForm.zil = data.data;
      }, error => {
        ElMessage({
          type: 'error',
          message: error.msg
        });
      }, {
        file: item.file
      });
    };
    // 重新上传事件
    const resubmitBtn = async formEl => {
      if (!resubmitForm.xy) {
        ElMessage({
          type: 'error',
          message: '请勾选协议'
        });
        return false;
      }
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          ajax('Merchant/editshop', res => {
            if (res.code == 0) {
              ElMessage({
                type: 'success',
                message: res.msg
              });
              show.value = false;
              getShop();
            }
          }, error => {
            ElMessage({
              type: 'error',
              message: error.msg
            });
            getShop();
          }, resubmitForm);
        } else {}
      });
    };
    const getxy = () => {
      router.push('/xy');
    };
    const options = Array.from({
      length: 10000
    }).map((_, idx) => ({
      value: `${idx + 1}`,
      label: `${idx + 1}`
    }));
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      const _component_BR = _resolveComponent("BR");
      return _openBlock(), _createElementBlock(_Fragment, null, [show.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules,
        "label-width": "120px",
        class: "demo-ruleForm",
        size: formSize.value,
        "status-icon": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "店铺名字",
          prop: "name",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.name = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "别名",
          prop: "ne",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.ne,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.ne = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "头像",
          prop: "img",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            "file-list": _ctx.fileList,
            "onUpdate:fileList": _cache[2] || (_cache[2] = $event => _ctx.fileList = $event),
            "show-file-list": false,
            "on-change": _ctx.handleChange,
            "http-request": getImg
          }, {
            default: _withCtx(() => [imageUrl.value ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              style: {
                "width": "150px"
              },
              src: imageUrl.value,
              class: "avatar"
            }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("点击上传")]),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list", "on-change"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "联系方式",
          prop: "phone",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ruleForm.phone = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "微信号",
          prop: "weixin",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.weixin,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ruleForm.weixin = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "营业执照",
          prop: "zil",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            "file-list": _ctx.fileList,
            "onUpdate:fileList": _cache[5] || (_cache[5] = $event => _ctx.fileList = $event),
            "show-file-list": false,
            "on-change": _ctx.handleChange,
            "http-request": getZil
          }, {
            default: _withCtx(() => [zilUrl.value ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              style: {
                "width": "150px"
              },
              src: zilUrl.value,
              class: "avatar"
            }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("点击上传")]),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list", "on-change"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "xy"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: ruleForm.xy,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ruleForm.xy = $event),
            "text-color": "#38c8a0",
            fill: "#38c8a0",
            class: "loginRemember"
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              onClick: getxy
            }, "《入驻协议》")]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = $event => submitForm(ruleFormRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode(" 提交 ")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "size"])])) : _createCommentVNode("", true), shop.value.zt == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, "审核中..等待审核结束")) : _createCommentVNode("", true), shop.value.zt == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createVNode(_component_BR), _createElementVNode("div", _hoisted_7, "失败原因:" + _toDisplayString(shop.value.msg), 1), _createVNode(_component_el_form, {
        rules: rules,
        style: {
          "margin-top": "36px"
        },
        model: resubmitForm,
        ref_key: "resubmitRuleFormRef",
        ref: resubmitRuleFormRef,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商铺名字",
          prop: "name",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: resubmitForm.name,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => resubmitForm.name = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "别名",
          prop: "ne",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: resubmitForm.ne,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => resubmitForm.ne = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "头像",
          prop: "img",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            "show-file-list": false,
            "http-request": resubmitgetImg
          }, {
            default: _withCtx(() => [resubmitImageUrl.value ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: resubmitImageUrl.value,
              style: {
                "width": "150px"
              },
              class: "avatar"
            }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("重新上传")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "联系方式",
          prop: "phone",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: resubmitForm.phone,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => resubmitForm.phone = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "微信号",
          prop: "weixin",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: resubmitForm.weixin,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => resubmitForm.weixin = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "营业执照",
          prop: "zil",
          style: {
            "width": "500px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            "show-file-list": false,
            "http-request": resubmitgetZil
          }, {
            default: _withCtx(() => [resubmitZilUrl.value ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: resubmitZilUrl.value,
              style: {
                "width": "150px"
              },
              class: "avatar"
            }, null, 8, _hoisted_9)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("重新上传")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "xy"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: resubmitForm.xy,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => resubmitForm.xy = $event),
            "text-color": "#38c8a0",
            fill: "#38c8a0",
            class: "loginRemember"
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              onClick: getxy
            }, "《入驻协议》")]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = $event => resubmitBtn(resubmitRuleFormRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode(" 重新申请 ")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["rules", "model"])])) : _createCommentVNode("", true)], 64);
    };
  }
};